import { makeApiCall } from '../../_common/api.utils';
import { API_URL, FIN_API_URL } from '../../const';

/***************** START GET FUNDER LIST ****************** */
export const getFunderDetailsList = (listData: any) => {
	const data = {
		GetAllInvestorDetailsToken: listData,
	};
	const url = `${API_URL}InvestorDetailsByCompanyID`;
	return makeApiCall(url, data);
};
/***************** END GET FUNDER LIST ****************** */

/** ***************** ADD FUNDER DETAILS START *********************** */
export const addFunderDetails = (addData: any) => {
	const data = {
		AddFunderDetailsToken: addData,
	};
	const url = `${API_URL}AddFunderDetailsWithToken`;
	return makeApiCall(url, data);
};
/** ***************** ADD FUNDER DETAILS END *********************** */

/** ***************** UPDATE FUNDER DETAILS START *********************** */
export const updateFunderDetails = (updateData: any) => {
	const data = {
		UpdateFunderDetailsToken: updateData,
	};
	const url = `${API_URL}UpdateFunderDetailsWithToken`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE FUNDER DETAILS END *********************** */

/** ***************** DELETE FUNDER DETAILS START *********************** */
export const deleteFunderDetails = (deleteData: any) => {
	const data = {
		DeleteFunderDetailsToken: deleteData,
	};
	const url = `${API_URL}DeleteFunderDetailsWithToken`;
	return makeApiCall(url, data);
};
/** ***************** DELETE FUNDER DETAILS END *********************** */
/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT START ************************** */
export const fetchInvestmentProductInvestmentAmount = (listData: any) => {
	const data = {
		FetchInvestmentProductInvestmentAmountToken: listData,
	};
	const url = `${API_URL}fetchInvestmenterProductInvestmentAmount`;
	return makeApiCall(url, data);
};
/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT END ************************** */

/************** FETCH ALL INVESTMENT MADE LIST START ************************** */
export const fetchAllInvestmentMadeList = (listData: any) => {
	const data = {
		FetchAllInvestmentMadeListToken: listData,
	};
	const url = `${API_URL}fetchAllInvestmentMadeList`;
	return makeApiCall(url, data);
};
/************** FETCH ALL INVESTMENT MADE LIST END ************************** */

/************** FETCH ALL INVESTMENT REPAYMENT LIST START ************************** */
export const getAllInvestmentRepaymentList = (listData: any) => {
	const data = {
		FetchAllInvestmentRepaymentListToken: listData,
	};
	const url = `${API_URL}getAllInvestmentRepayment`;
	return makeApiCall(url, data);
};
/************** FETCH ALL INVESTMENT REPAYMENT LIST END ************************** */

/************** CREATE INVESTOR MADE START ************************** */
export const createInvestorMadeFun = (listData: any) => {
	const data = {
		createInvestorMadeToken: listData,
	};
	const url = `${API_URL}createInvestorMade`;
	return makeApiCall(url, data);
};
/************** CREATE INVESTOR MADE END ************************** */

/************** GET INVESTOR DETAILS START ************************** */
export const getInvestorDetailsFun = (listData: any) => {
	const data = {
		getInvestorDetailsToken: listData,
	};
	const url = `${API_URL}getInvestorDetails`;
	return makeApiCall(url, data);
};
/************** GET INVESTOR DETAILS END ************************** */

/************** GET INVESTOR DETAILS START ************************** */
export const getBranchAccountListFun = (listData: any) => {
	const data = {
		getBranchAccountListToken: listData,
	};
	const url = `${FIN_API_URL}getBranchAccountList`;
	return makeApiCall(url, data);
};
/************** GET INVESTOR DETAILS END ************************** */

/************** GET INVESTOR DETAILS START ************************** */
export const getRepaymentScheduleDetails = (listData: any) => {
	const data = {
		getRepaymentScheduleDetailsToken: listData,
	};
	const url = `${API_URL}getRepaymentSchedule`;
	return makeApiCall(url, data);
};
/************** GET INVESTOR DETAILS END ************************** */
